import { GroupedResults } from './dto';

export type TrackingData = Record<string, any>;
export type TrackFunc = (data: TrackingData) => void;

export function pageSectionFromGroupedResults(gr: GroupedResults): string {
  switch (gr.Specific) {
    case 'campaign':
      return 'campaigns';
    case 'charity':
      return 'charities';
    case 'fundraiser':
      return 'fundraisers';
    case 'localproject':
      return 'crowdfunding pages';
    case 'teamsv1':
      return 'teams';
    case 'page':
      return 'pages';
  }
}
